export default __webpack_public_path__ + "static/media/JavaScript_-_adamr.space___Codecademy.17d4a1a7.pdf";